'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Divider } from '@heroui/react';
import Link from 'next/link';
import { cn } from '@/lib/utils';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { AuthForm } from '../../../components/form/auth-form';
import { usePreRegisterForm } from '../../hooks/use-pre-register-form';
import AddAddressModal from '../modals/add-address-modal';
import { PreRegisterAlreadyExistsState } from './pre-register-already-exists-state';
import { PreRegisterFormFields } from './pre-register-form-fields';
import { PreRegisterSuccessState } from './pre-register-success-state';
interface PreRegisterFormProps {
  variant?: 'register' | 'learn-more';
}
export default function PreRegisterForm(t0) {
  const $ = _c(19);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "register" : t1;
  const form = usePreRegisterForm();
  const isLearnMore = variant === "learn-more";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("size-auto mx-auto w-full max-w-xl rounded-2xl p-8", "bg-background shadow-sm");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== form.submitStatus) {
    t3 = form.submitStatus === "success" && <PreRegisterSuccessState />;
    $[1] = form.submitStatus;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== form.resetForm || $[4] !== form.submitStatus) {
    t4 = form.submitStatus === "already_exists" && <PreRegisterAlreadyExistsState onReset={form.resetForm} />;
    $[3] = form.resetForm;
    $[4] = form.submitStatus;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== form || $[7] !== isLearnMore) {
    t5 = form.submitStatus === "idle" && <><PreRegisterFormFields {...form} />{!isLearnMore && <><div className="flex w-full items-center gap-2 text-default-700"><Divider className="w-1/3 bg-secondary" /><span className="w-full text-center text-sm">Já possui uma conta?</span><Divider className="w-1/3 bg-secondary" /></div><Link href={APP_ROUTES.PUBLIC.LOGIN} className="w-full"><Button variant="solid" color="primary" className="w-full font-medium">Fazer login</Button></Link></>}</>;
    $[6] = form;
    $[7] = isLearnMore;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== form.addAddressModal || $[10] !== form.preRegistration || $[11] !== form.setPreRegistration || $[12] !== form.submitStatus) {
    t6 = form.submitStatus === "idle" && <AddAddressModal preRegistration={form.preRegistration} setPreRegistration={form.setPreRegistration} isOpen={form.addAddressModal.isOpen} onOpenChange={form.addAddressModal.onOpenChange} onClose={form.addAddressModal.onClose} />;
    $[9] = form.addAddressModal;
    $[10] = form.preRegistration;
    $[11] = form.setPreRegistration;
    $[12] = form.submitStatus;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <AuthForm.Root className={t2}>{t3}{t4}{t5}{t6}</AuthForm.Root>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}